import React from "react"
import { Dialog, FlatButton, TextField, SelectField, MenuItem, Toggle } from "material-ui"
import DoubleField from "../../common/DoubleField"
import PercentField from "../../common/PercentField"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import { IPayClass } from "../../../models"
import AccountStore from "../../../stores/AccountStore"
import * as utils from "../../../helpers/utils"
import * as payGroupAndTypeHelper from "../../../helpers/payGroupAndTypeHelper"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import _ from "lodash"
import userStore from "../../../stores/UserStore"


interface IProps {
    readonly?: boolean
    editPayClass: IPayClass
    existingPayClasses: IPayClass[]
    availablePayTypeIds?: string[]
    handleClose(): void
    handleAdd(payClass: IPayClass): void
    handleUpdate(payClass: IPayClass): void
    employeeSelected?:boolean
}
interface IState {
    name: string
    errorName: string
    code: string
    payTypeId: string
    errorPayTypeId: string
    payRate: string
    billRate: string
    burden: number
    overtimeFactor: string
    doubleOvertimeFactor: string
    errorBurden: boolean
    hideOnESS: boolean
   useEmployeeBasePayRate:boolean
   basePayRateAddition?:string
   usePayRateAdditionPercentage:boolean
   BasePayRateAdditionPercentage?:string
   errorBasePayRatePercentagae:string
   
   

}

export default class AddPayClassDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            name: props.editPayClass ? props.editPayClass.Name : "",
            errorName: "",
            code: props.editPayClass && props.editPayClass.Code ? props.editPayClass.Code : "",
            payTypeId: props.editPayClass ? props.editPayClass.PayTypeId : null,
            errorPayTypeId: "",
            payRate: props.editPayClass && props.editPayClass.PayInfo && props.editPayClass.PayInfo.PayRate ? props.editPayClass.PayInfo.PayRate.toString() : "",
            billRate: props.editPayClass && props.editPayClass.PayInfo && props.editPayClass.PayInfo.BillRate ? props.editPayClass.PayInfo.BillRate.toString() : "",
            burden: props.editPayClass && props.editPayClass.PayInfo ? props.editPayClass.PayInfo.Burden : 0,
            overtimeFactor: props.editPayClass && props.editPayClass.PayInfo ? (props.editPayClass.PayInfo.OvertimeBillFactor == 0 ? "1.5" : props.editPayClass.PayInfo.OvertimeBillFactor.toString()) : "1.5",
            doubleOvertimeFactor: props.editPayClass && props.editPayClass.PayInfo ? (props.editPayClass.PayInfo.DoubleTimeBillFactor == 0 ? "2.0" : props.editPayClass.PayInfo.DoubleTimeBillFactor.toString()) : "2",
            errorBurden: false,
            hideOnESS: props.editPayClass ?
                props.editPayClass.HideOnESS :
                false,
                useEmployeeBasePayRate: props.editPayClass && props.editPayClass.PayInfo ? props.editPayClass.PayInfo.UseEmployeeBasePayRate : false,
                basePayRateAddition: props.editPayClass && props.editPayClass.PayInfo && props.editPayClass.PayInfo.BasePayRateAddition ? props.editPayClass.PayInfo.BasePayRateAddition.toString() : "", 
                usePayRateAdditionPercentage:props.editPayClass && props.editPayClass.PayInfo && props.editPayClass.PayInfo.UsePayRateAdditionPercentage ? props.editPayClass.PayInfo.UsePayRateAdditionPercentage : false,
                BasePayRateAdditionPercentage:props.editPayClass && props.editPayClass.PayInfo && props.editPayClass.PayInfo.BasePayRateAdditionPercentage ? props.editPayClass.PayInfo.BasePayRateAdditionPercentage.toString() : "",
                errorBasePayRatePercentagae:""


        }
        autobind(this)

    }
    

    handleRequestSave() {
        if (!this.checkValidate()) return
        const payload = this.props.editPayClass ?
            _.cloneDeep(this.props.editPayClass) :
            {
                Id: utils.guid(),
                PayInfo: {}
            } as IPayClass

        payload.Name = this.state.name.trim()
        payload.Code = this.state.code ? this.state.code.trim() : null
        payload.PayTypeId = this.state.payTypeId
        payload.PayInfo.BillRate = this.state.billRate ? parseFloat(this.state.billRate) : 0
        payload.PayInfo.PayRate = this.state.useEmployeeBasePayRate ? 0 : this.state.payRate ? parseFloat(this.state.payRate) : 0
        payload.PayInfo.Burden = this.state.burden
        payload.PayInfo.OvertimeBillFactor = parseFloat(this.state.overtimeFactor)
        payload.PayInfo.DoubleTimeBillFactor = parseFloat(this.state.doubleOvertimeFactor)
        payload.HideOnESS = this.state.hideOnESS
        payload.PayInfo.BasePayRateAddition = this.state.useEmployeeBasePayRate && this.state.basePayRateAddition ? parseFloat(this.state.basePayRateAddition) : 0
        payload.PayInfo.UseEmployeeBasePayRate = this.state.useEmployeeBasePayRate
        payload.PayInfo.UsePayRateAdditionPercentage = this.state.useEmployeeBasePayRate && this.state.usePayRateAdditionPercentage
        payload.PayInfo.BasePayRateAdditionPercentage =  this.state.useEmployeeBasePayRate && this.state.usePayRateAdditionPercentage ? parseFloat(this.state.BasePayRateAdditionPercentage): 0
        this.props.editPayClass ?
            this.props.handleUpdate(payload) :
            this.props.handleAdd(payload)
    }

    checkValidate() {
        let isValid = true

        if (!this.state.name.trim()) {
            this.setState({ errorName: strings.This_field_is_required })
            isValid = false
        }
        else {
            const existingNames = this.props.existingPayClasses
                .filter(item => this.props.editPayClass ? item.Id !== this.props.editPayClass.Id : true)
                .map(item => item.Name)
            if (existingNames.includes(this.state.name.trim())) {
                this.setState({ errorName: strings.Name_is_duplicated })
                isValid = false
            }
            else {
                this.setState({ errorName: "" })
            }
        }

        if (!this.state.payTypeId) {
            this.setState({ errorPayTypeId: strings.This_field_is_required })
            isValid = false
        }
        else {
            if (this.props.availablePayTypeIds && !this.props.availablePayTypeIds.includes(this.state.payTypeId)) {
                this.setState({ errorPayTypeId: strings.This_PayType_is_invalid })
                isValid = false
            }
            else {
                this.setState({ errorPayTypeId: "" })
            }
        }

        if (this.state.useEmployeeBasePayRate && this.state.usePayRateAdditionPercentage && !this.state.BasePayRateAdditionPercentage) {
            this.setState({errorBasePayRatePercentagae:strings.This_field_is_required})
            isValid = false
            
        }
        else if ( this.state.useEmployeeBasePayRate && this.state.usePayRateAdditionPercentage && this.state.BasePayRateAdditionPercentage === "0") {
            this.setState({errorBasePayRatePercentagae:strings.This_field_requires_a_number_greater_than_0}) 
            isValid = false
        }
        else {
            this.setState({errorBasePayRatePercentagae:""})
        }

        if (this.state.errorBurden)
            isValid = false

        return isValid
    }

    getOTRate() {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        if (this.state.payRate === "") {
            return "$0.00"
        }
        return formatter.format(parseFloat(this.state.payRate) * parseFloat(this.state.overtimeFactor))
    }

    getOT2Rate() {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        if (this.state.payRate === "") {
            return "$0.00"
        }
        return formatter.format(parseFloat(this.state.payRate) * parseFloat(this.state.doubleOvertimeFactor))
    }

    getOTBillRate() {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        if (this.state.billRate === "") {
            return "$0.00"
        }
        return formatter.format(parseFloat(this.state.billRate) * parseFloat(this.state.overtimeFactor))
    }

    getOT2BillRate() {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        if (this.state.billRate === "") {
            return "$0.00"
        }
        return formatter.format(parseFloat(this.state.billRate) * parseFloat(this.state.doubleOvertimeFactor))
    }

    toggleUseBaseRate(e, useEmployeeBasePayRate){
        if (userStore.getCurrentUserDetail()) {
            this.setState({ useEmployeeBasePayRate, payRate: userStore.getCurrentUserDetail() ? userStore.getCurrentUserDetail().PayRate : 0 })
        } else {
            this.setState({ useEmployeeBasePayRate, payRate:"" },)
        }
         
    }
    
    handleBaseRateAdd(e){
        if (e.target.value === "" || utils.validateDouble(e.target.value)){
        if (userStore.getCurrentUserDetail()) {
            if (userStore.getCurrentUserDetail().PayRate > 0 ){
            
                this.setState({ basePayRateAddition: e.target.value,  },() => this.setState({payRate: String(Number(e.target.value) + Number(userStore.getCurrentUserDetail().PayRate))}))
            } else {
                this.setState({ basePayRateAddition: e.target.value, payRate:e.target.value })
            }
        } else {
            this.setState({ basePayRateAddition: e.target.value,payRate:e.target.value })
        }
    }
    }

    handleBaseRateAddPercent(e){ 
        if (e.target.value === "" || utils.validateDouble(e.target.value)) {
        if (userStore.getCurrentUserDetail()) {
            this.setState(
                {
                    BasePayRateAdditionPercentage: e.target.value,
                    payRate: String(userStore.getCurrentUserDetail().PayRate + (e.target.value / 100) * userStore.getCurrentUserDetail().PayRate),
                    basePayRateAddition: ""
                },
                () => this.checkValidate()
            )
        } else {
            this.setState({
                BasePayRateAdditionPercentage: e.target.value,
                payRate: "",
                basePayRateAddition: ""
            })
        }
    }
    
    }

    togglePayRatePercent (e, usePayRateAdditionPercentage) {
        
         this.setState({ usePayRateAdditionPercentage,basePayRateAddition:"", }, () => this.checkValidate())}

    render() {
        return (
            <Dialog
                open
                title={this.props.readonly ? strings.Pay_Class : this.props.editPayClass ? strings.Edit_Pay_Class : strings.Add_Pay_Class}
                actions={
                    this.props.readonly ?
                        <FlatButton data-intercom-target={"Payclass-Btn-CloseAddPayclassDialog"} label={strings.Close} primary onTouchTap={this.props.handleClose} /> :
                        [
                            <FlatButton data-intercom-target={"Payclass-Btn-CloseAddPayclassDialog"} key="cancel" label={strings.CANCEL} secondary onTouchTap={this.props.handleClose} />,
                            <FlatButton data-intercom-target={"Payclass-Btn-SavePayclass"} key="save" label={this.props.editPayClass ? strings.Save : strings.Add} primary onTouchTap={this.handleRequestSave} />
                        ]
                }
                style={{ padding: "0 60px" }}
                autoScrollBodyContent={true}
            >
                <div style={{ marginTop: 16 }}>
                    <div style={{ display: "flex" }}>
                        <div style={{ flex: 1 }}>
                            <TextField
                                data-intercom-target={"Payclass-AddPayclass-Entry-Name"}
                                floatingLabelText={strings.Name}
                                value={this.state.name}
                                errorText={this.state.errorName}
                                onChange={(e) => this.setState({ name: e.target.value }, () => this.checkValidate())}
                                errorStyle={{ position: "absolute", top: 70 }}
                                disabled={this.props.readonly}
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <TextField
                                data-intercom-target={"Payclass-AddPayclass-Entry-Code"}
                                floatingLabelText={strings.Code}
                                value={this.state.code}
                                onChange={e => this.setState({ code: e.target.value })}
                                disabled={this.props.readonly}
                            />
                        </div>
                    </div>
                    {permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.ViewRates) &&
                        <div style={{ display: "flex" }}>
                            <div style={{ flex: 1, display: "flex" }}>
                                <span style={{ marginTop: 40, marginRight: 5 }}>$</span>
                                <DoubleField
                                    name="PayRate"
                                    label={strings.Pay_Rate}
                                    value={this.state.payRate}
                                    handleChange={payRate => this.setState({ payRate })}
                                    readonly={this.props.readonly || !permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.EditRates) || this.state.useEmployeeBasePayRate}
                                />
                            </div>
                            <div style={{ flex: 1, display: "flex" }}>
                                <span style={{ marginTop: 40, marginRight: 5 }}>$</span>
                                <DoubleField
                                    name="BillRate"
                                    label={strings.Bill_Rate}
                                    value={this.state.billRate}
                                    handleChange={billRate => this.setState({ billRate })}
                                    readonly={this.props.readonly || !permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.EditRates)}
                                />
                            </div>
                        </div>
                    }
                    {permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.ViewRates) &&
                        this.state.payTypeId && payGroupAndTypeHelper.getPayTypeById(this.state.payTypeId).UseTowardsOvertime &&
                        <div style={{ display: "flex" }}>
                            <div style={{ flex: 1, display: "flex" }}>
                                <div>
                                    <DoubleField
                                        name="OvertimeFactor"
                                        label={strings.OvertimeFactor}
                                        value={this.state.overtimeFactor}
                                        handleChange={overtimeFactor => this.setState({ overtimeFactor })}
                                        readonly={this.props.readonly || !permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.EditRates)}
                                    />
                                    <div>Pay: {this.getOTRate()}</div>
                                    <div>Bill: {this.getOTBillRate()}</div>
                                </div>
                            </div>
                            {!AccountStore.getHideOT2() &&
                                <div style={{ flex: 1, display: "flex" }}>
                                    <div>
                                        <DoubleField
                                            name="DoubleOvertimeFactor"
                                            label={strings.DoubleOvertimeFactor}
                                            value={this.state.doubleOvertimeFactor}
                                            handleChange={doubleOvertimeFactor => this.setState({ doubleOvertimeFactor })}
                                            readonly={this.props.readonly || !permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.EditRates)}
                                        />
                                        <div>Pay: {this.getOT2Rate()}</div>
                                        <div>Bill: {this.getOT2BillRate()}</div>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    <div style={{ display: "flex" }}>
                        {permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.ViewRates) &&
                            <div style={{ flex: 1 }}>
                                <PercentField
                                    label={strings.Burden}
                                    percent={this.state.burden}
                                    handleChange={(burden, errorBurden) => this.setState({ burden, errorBurden })}
                                    readonly={this.props.readonly || !permissionHelper.hasPermission(AuthenticationStore.Permissions.Account.EditRates)}
                                />
                            </div>
                        }
                        <div style={{ flex: 1 }}>
                            <SelectField
                                data-intercom-target={"Payclass-AddPayclass-Select-Paytype"}
                                floatingLabelText={strings.Pay_Type}
                                value={this.state.payTypeId}
                                onChange={(event, index, value) => this.setState({ payTypeId: value }, () => this.checkValidate())}
                                errorText={this.state.errorPayTypeId}
                                errorStyle={{ position: "absolute", bottom: -10 }}
                                disabled={this.props.readonly}
                            >
                                {AccountStore.getCurrentAccount().PayTypes
                                    .filter(item => {
                                        if (this.props.availablePayTypeIds) {
                                            const showedPayTypeIds = _.cloneDeep(this.props.availablePayTypeIds)
                                            this.props.editPayClass && this.props.editPayClass.PayTypeId &&
                                                showedPayTypeIds.push(this.props.editPayClass.PayTypeId)
                                            return showedPayTypeIds.includes(item.Id)
                                        }
                                        else {
                                            return true
                                        }
                                    })
                                    .map((item, i) =>
                                        <MenuItem
                                            key={i}
                                            value={item.Id}
                                            primaryText={item.Name}
                                            disabled={this.props.availablePayTypeIds ? !this.props.availablePayTypeIds.includes(item.Id) : false}
                                        />
                                    )}
                            </SelectField>
                        </div>
                    </div>
                    <div style={{ display: "flex", marginTop: 20, alignItems: "flex-start" }}>
                        {AccountStore.getUseBasePayRateInPayClassEnabled() &&<div style={{ flex: 1 }}>
                            <Toggle
                                label={strings.Use_Employee_Base_Pay_Rate}
                                disabled={this.props.readonly}
                                style={{ width: "auto", flex: 1 }}
                                toggled={this.state.useEmployeeBasePayRate}
                                onToggle={this.toggleUseBaseRate}
                            />
                        </div>}
                        { AccountStore.getUseBasePayRateInPayClassEnabled() &&this.state.useEmployeeBasePayRate && (
                            <div style={{ flex: 1, marginTop: "-20px" }}>
                                <span style={{ marginTop: 40, marginRight: 5 }}>$</span>
                                <TextField
                                    data-intercom-target={"Base-Pay-Rate-Addition"}
                                    floatingLabelText={strings.Base_Pay_Rate_Addition}
                                    value={this.state.basePayRateAddition}
                                    onChange={this.handleBaseRateAdd}
                                    errorStyle={{ position: "absolute", top: 70 }}
                                    disabled={this.props.readonly || this.state.usePayRateAdditionPercentage}
                                />
                            </div>
                        )}
                    </div>
                    { AccountStore.getUseBasePayRateInPayClassEnabled() &&this.state.useEmployeeBasePayRate && (
                        <div style={{ display: "flex", marginTop: 20, alignItems: "flex-start" }}>
                            <div style={{ flex: 1 }}>
                                <Toggle
                                    label={strings.Use_Pay_Rate_Addition_Percentage}
                                    disabled={this.props.readonly}
                                    style={{ width: "250px", flex: 1 }}
                                    toggled={this.state.usePayRateAdditionPercentage}
                                    onToggle={this.togglePayRatePercent}
                                />
                            </div>
                            { AccountStore.getUseBasePayRateInPayClassEnabled() &&this.state.useEmployeeBasePayRate && this.state.usePayRateAdditionPercentage && (
                                <div style={{ flex: 1, marginTop: "-20px" }}>
                                    <span style={{ marginTop: 40, marginRight: 5 }}>%</span>
                                    <TextField
                                        data-intercom-target={"Base-Pay-Rate-Addition-Percentage"}
                                        floatingLabelText={strings.Base_Pay_Rate_Addition_Percentage}
                                        value={this.state.BasePayRateAdditionPercentage}
                                        errorText={this.state.errorBasePayRatePercentagae}
                                        onChange={this.handleBaseRateAddPercent
                                        }
                                        errorStyle={{ position: "absolute", top: 70 }}
                                        disabled={this.props.readonly}
                                        type="text"
                                        pattern={"^[0-9]*$"}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                    {AccountStore.getShowPayClassOnESS() && (
                        <div style={{ marginTop: 20 }}>
                            <Toggle
                                label={strings.Hide_On_ESS}
                                disabled={this.props.readonly}
                                style={{ width: 170 }}
                                toggled={this.state.hideOnESS}
                                onToggle={(e, hideOnESS) => this.setState({ hideOnESS })}
                            />
                        </div>
                    )}
                </div>
            </Dialog>
        )
    }
}